"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTodayStringFormat = exports.longDateDisplayFormat = void 0;
var _moment = _interopRequireDefault(require("moment"));
require("moment/locale/en-au");
const longDateDisplayFormat = () => _moment.default.localeData('en-AU').longDateFormat('L');
exports.longDateDisplayFormat = longDateDisplayFormat;
const withTodayStringFormat = date => (0, _moment.default)(date || new Date()).calendar(null, {
  sameDay: '[[Today], DD/MM/YYYY]',
  nextDay: 'DD/MM/YYYY',
  nextWeek: 'DD/MM/YYYY',
  lastDay: 'DD/MM/YYYY',
  lastWeek: 'DD/MM/YYYY',
  sameElse: 'DD/MM/YYYY'
});
exports.withTodayStringFormat = withTodayStringFormat;